<template>
  <div class="home">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <Header />
    <Treatments />
    <Booking />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Header from '@/components/Header.vue'
import Treatments from '@/components/Treatments.vue'
import Booking from '@/components/Terapist.vue'

export default {
  name: 'HomeView',
  components: {
    // HelloWorld,
    Header,
    Treatments,
    Booking
  }
}
</script>

<style lang="scss">



</style>